import { action, computed, observable } from 'mobx'

import { ISharedDelivery } from '~/client/graph'
import DeliveryStatus from '~/client/src/shared/constants/DeliveryStatus'

import { getSharedProjectName } from '../../models/SharedInfo'

export default class SharedDeliveriesStore {
  private sharedDeliveries = observable(new Map<string, ISharedDelivery>())

  private get byId() {
    return this.sharedDeliveries
  }

  public getById = (id: string): ISharedDelivery => {
    if (this.byId.has(id)) {
      return this.byId.get(id)
    }
  }

  @action.bound
  public clearList() {
    this.byId.clear()
  }

  @computed
  public get list(): ISharedDelivery[] {
    return Array.from(this.byId.values()).filter(
      sp => sp.status !== DeliveryStatus.Deleted,
    )
  }

  @computed
  public get projectFromIdToCodeMap(): { [projectFromId: string]: string } {
    return this.list.reduce(
      (acc, sp) => {
        acc[sp.projectFromId] = getSharedProjectName(sp.projectUrl)
        return acc
      },
      {} as { [projectFromId: string]: string },
    )
  }

  @action.bound
  public receiveList(list: ISharedDelivery[]) {
    this.byId.clear()

    list.forEach(dto => {
      this.byId.set(dto.id, dto)
    })
  }

  @action.bound
  public receiveOne(id: string, dto: ISharedDelivery) {
    if (dto) {
      this.byId.set(id, dto)
    } else {
      this.byId.delete(id)
    }
  }
}
